module.exports = __webpack_public_path__ + "img/vertical_7_1_9016.d9cd5e9c.png";